import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpBackend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

const supportedLocales = (import.meta.env.VITE_SUPPORTED_LOCALES ?? 'en,fr,de,es').split(',')
const defaultLocale = import.meta.env.VITE_DEFAULT_LOCALE ?? 'en'

void i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: defaultLocale,
    supportedLngs: supportedLocales,
    defaultNS: 'translation',
    ns: ['translation'],
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'th-language',
    },
    interpolation: {
      escapeValue: false,
    },
  })

// Screen readers and the browser pick pronunciation and hyphenation from <html lang>.
function syncDocumentLanguage(language: string | undefined) {
  if (language && typeof document !== 'undefined') document.documentElement.lang = language
}
i18n.on('languageChanged', syncDocumentLanguage)
syncDocumentLanguage(i18n.resolvedLanguage)

export { i18n }
